import React from "react"
import ReactDOM from "react-dom/client"
import { BrowserRouter as Router, Route, Routes } from "react-router-dom"
import Accueil from "./views/Accueil/Accueil"
import Services from "./views/Services/Services"
import Projets from "./views/Projets/Projets"
import Portfolio from "./views/Portfolio/Portfolio"
import Error from "./components/Error/Error"
import Header from "./components/Header/Header"
import Footer from "./components/Footer/Footer"
import ProjectPage from "./views/ProjectPage/ProjectPage"
import { createGlobalStyle } from "styled-components"
import "./index.css"
import ScrollToTop from "./utils/hooks/ScrollToTop"


const GlobalStyle = createGlobalStyle`
    #root {
        min-height: 60em;
    }

    p{
       
    }

    body{
        margin: 0;
    }

    h1, h2{
        font-family: 'Archivo Black', sans-serif;       
    }

    button{
        font-family: 'Inter', sans-serif;
    }
`

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
    <React.StrictMode>
        <Router>
        <GlobalStyle />
            <ScrollToTop />
            <Header />
            <Routes>
                <Route path="/" element={<Accueil />} />
                <Route path="/Services" element={<Services />} />
                <Route path="/Projets" element={<Projets />} />
                <Route path="/Portfolio" element={<Portfolio />} />
                <Route path="/projet/:slug" element={<ProjectPage />} />
                <Route path="*" element={<Error />} />
            </Routes>
            <Footer />
        </Router>
    </React.StrictMode>
)